import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';

export const sortByDate = (a: BaseDto, b: BaseDto) => {
  return a.createdAt && b.createdAt
    ? a.createdAt.getTime() - b.createdAt.getTime()
    : a.createdAt
    ? 1
    : -1;
};

export const inboxAllowedImageExtensions = ['heic', 'jpeg', 'jpg', 'png', 'tiff'];
